<template>
  <el-dialog title="预约任务列表" :visible.sync="dialogVisible" width="50%">
    <el-table :data="reservationList" border>
      <el-table-column prop="taskName" label="任务名称"></el-table-column>
      <el-table-column prop="executeTime" label="执行时间"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0">待执行</el-tag>
          <el-tag v-if="scope.row.status === 1">执行中</el-tag>
          <el-tag v-if="scope.row.status === 2">成功</el-tag>
          <el-tag v-if="scope.row.status === 3">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <div style="display: flex; gap: 8px;">
            <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            <el-button size="mini" @click="handleViewLog(scope.row)">日志</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 50]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
    </el-pagination>

    <el-dialog title="修改执行时间" :visible.sync="editDialogVisible" width="30%" append-to-body>
      <el-form :model="editForm" ref="editForm" label-width="100px">
        <el-form-item label="执行时间">
          <el-date-picker
              v-model="editForm.executeTime"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEdit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="任务日志" :visible.sync="logDialogVisible" width="50%" append-to-body>
      <el-table :data="logContent" border v-if="logContent && logContent.length > 0">
        <el-table-column prop="text" label="日志内容"></el-table-column>
        <el-table-column prop="msg" label="日志信息">
          <template slot-scope="scope">
            {{ scope.row.msg || '暂无内容' }}
          </template>
        </el-table-column>
      </el-table>
      <div v-else>暂无日志</div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import vivoBatchEditApi from '@/api/modules/vivoBatchEditApi'
import { get, post } from '../../until/controlRequest'

export default {
  data() {
    return {
      dialogVisible: false,
      editDialogVisible: false,
      logDialogVisible: false,
      reservationList: [],
      current: 1,
      size: 20,
      total: 0,
      currentRow: null,
      editForm: {
        id: null,
        executeTime: ''
      },
      logContent: []  // 修改为数组，便于表格渲染
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.fetchReservationList()
    },

    async fetchReservationList() {
        const params = {
            current: this.current,
            size: this.size,
        }
        get('/v1/vivo-accounts/batchReserveFastFlow/page', params)
            .then(data => {
                this.reservationList = data.records || []
                this.total = data.total || 0
            })
            .catch(() => {
                this.reservationList = []
                this.total = 0
            })
    },

    handleSizeChange(val) {
      this.size = val
      this.fetchReservationList()
    },

    handleCurrentChange(val) {
      this.current = val
      this.fetchReservationList()
    },

    handleEdit(row) {
      this.currentRow = { ...row }
      this.editForm.id = row.id
      this.editForm.executeTime = row.executeTime
      this.editDialogVisible = true
    },

    async confirmEdit() {
      try {
        const res = await vivoBatchEditApi.update(this.editForm)
        if (res.data.success) {
          this.$message.success('修改成功')
          this.editDialogVisible = false
          this.fetchReservationList()
        } else {
          this.$message.error(res.data.message || '修改失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('修改失败')
      }
    },

    handleDelete(row) {
      this.$confirm('确认删除该预约任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await vivoBatchEditApi.delete(row.id)
          if (res.data.success) {
            this.$message.success('删除成功')
            this.fetchReservationList()
          } else {
            this.$message.error(res.data.message || '删除失败')
          }
        } catch (error) {
          console.error(error)
          this.$message.error('删除失败')
        }
      })
    },

    async handleViewLog(row) {
      try {
        const res = await vivoBatchEditApi.logList(row.id)
        if (res.data.success) {
          // 将日志内容设置为数组形式以便表格展示
          this.logContent = res.data.data || []
          this.logDialogVisible = true
        } else {
          this.$message.error(res.data.message || '获取日志失败')
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取日志失败')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/vivo/ReservationView.vue